/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PrefetchedDataGql } from '@jira/software__backlog-load-agility-graphql-data/src/PrefetchedDataGql.types.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_NEXTGEN_BACKLOG } from './resourceTypeNextgenBacklog.constants.tsx';

export const backlogResource: RouteResource<PrefetchedDataGql | null> =
	createResource<PrefetchedDataGql | null>({
		type: RESOURCE_TYPE_NEXTGEN_BACKLOG,
		getKey: ({ match }) => match.params.boardId || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-nextgen-common", jiraSpaEntry: "async-nextgen-common" */ './GetDataGetData.tsx'
			),
		// SSR doesn't care about this and we can't check FFs here because its not in the render path
		maxAge: 1000 * 60 * 60, // 1 hour max age
		isBrowserOnly: true,
	});
